export enum AppFeaturesList {
    API_TOKENS = 'api-tokens',
    BROWSER_NOTIFICATIONS = 'browser-notifications',
    CHARGEBEE_PORTAL = 'chargebee-portal',
    CONTENT_STORE_BANNER = 'content-marketplace-banner',
    CONTENT_STORE_POC = 'content-marketplace-poc',
    EVENTS_MANAGEMENT = 'events-management',
    FREE_TRIAL_NOTIFICATION_LOGIC_REFACTOR = 'free-trial-notification-logic-refactor',
    GROUPS_REPORTING_MANAGER = 'groups-reporting-manager',
    LANGUAGE_SELECTOR = 'language-selector',
    MERGE_INTEGRATION = 'merge-integration',
    NOTIFICATIONS = 'notifications',
    PLATFORM_LOGIN = 'platform-login',
    SSO_ON_ANDROID = 'sso-on-android',
    QUIZ_PAGE_SETTINGS = 'quiz-page-settings',
    MERGE_INTEGRATION_SUPPORTED_PLATFORMS = 'merge-integration-supported-platforms',
    COURSE_BUILDER_REWORK = 'course-builder-rework',
}
